import { botEnvironments } from "./chat.environment";
import { AutomatedTestingEnvironment } from "./automated_test.environment";
import { conversationVisualizerEnvironments } from "./conversation-visualizer.environment"; 

export const environment = {
  production: false,
  mockAuth: false,
  userManagementApiUrl: "https://api-botspace-dev.copec.cl",
  baseApiUrl: "https://api-botspace-dev.copec.cl",
  name: "Desarrollo",
  env: "dev",
  chat: botEnvironments,
  chatEvent: {
    wsEndpoint: "wss://72xvdgrg6va6jb5l6yynhvnzt4.appsync-realtime-api.us-west-2.amazonaws.com/event/realtime",
    wsApiKey: "da2-zjt3bg5kxfeg3j3az74wvawkxa"
  },
  conversationVisualizer: conversationVisualizerEnvironments,
  automatedTesting: AutomatedTestingEnvironment,
  auth: {
    issuer: 'https://copec-sa.fusionauth.io',
    clientId: '12dc4706-0a48-48af-9001-2a1c96f33bda',
    scope: 'openid profile email offline_access',
    showDebugInformation: true
  }
};
